import React from 'react';
import { useTranslation } from 'react-i18next';

function LanguageSwitcher({ className = 'language-switcher' }) {
  const { i18n } = useTranslation();

  const changeLanguage = (lng) => {
    if (i18n.language !== lng) {
      i18n.changeLanguage(lng);
    }
  };

  return (
    <div className={className}>
      <button 
        onClick={() => changeLanguage('de')}
        className={i18n.language === 'de' ? 'active' : ''}
      >
        DE
      </button>
      <button 
        onClick={() => changeLanguage('en')}
        className={i18n.language === 'en' ? 'active' : ''}
      >
        EN
      </button>
    </div>
  );
}

export default LanguageSwitcher; 